<template>
  <div v-if="clickLimit >= 0" class="invite-wrap">
    <form
      id="invite"
      v-if="!formSuccess"
      @submit="checkForm"
      action="#"
      method="post"
      novalidate="true"
    >
      <label for="email"
        >{{ $t("plan.inviteForm.modal.text") }}&emsp;&emsp;{{
          $t("plan.inviteForm.modal.invitationsLeft")
        }}: <span class="error">{{ invitationsLeft }}</span></label
      >
      <div v-for="(email, index) in emails" v-bind:key="index">
        <div class="input-wrapper">
          <input
            v-bind:class="{ error: emails[index].error, email: true }"
            v-bind:id="'email-' + index"
            v-bind:name="'email' + index"
            v-model="emails[index].email"
            v-bind:placeholder="$t('plan.inviteForm.placeholder')"
            v-on:input="emails[index].error = false"
          />
          <div
            v-if="index + 1 === emails.length && clickLimit > 0"
            class="add action"
            @click="addField"
          ></div>
          <div
            v-else-if="index + 1 === emails.length && clickLimit <= 0"
            class="blank action"
          ></div>
          <div
            v-if="index + 1 < emails.length"
            class="remove action"
            @click="removeField(index)"
          ></div>
        </div>
        <p class="error errorMsg" v-if="emails[index].error">
          {{
            email.email.length > 0
              ? $t("plan.inviteForm.errorMsg.invalidEmail")
              : $t("plan.inviteForm.errorMsg.noEmail")
          }}
        </p>
      </div>

      <input
        type="submit"
        class="submit"
        v-bind:value="$t('plan.inviteForm.modal.button')"
      />
    </form>
    <div v-if="formSuccess" class="success-message">
      <h3>{{ $t("plan.inviteForm.infoMsg") }}:</h3>
      <ul>
        <li v-for="(email, idx) in emails" v-bind:key="idx">
          {{ email.email }}
        </li>
      </ul>
    </div>
  </div>
  <div v-else-if="clickLimit < 0">
    <h3>{{ $t("plan.inviteForm.modal.limitMsg") }}</h3>
    <br />
  </div>
</template>

<script>
import { validEmail } from "@/utils/validEmail";
import { planService } from "@/services/plan.service";

export default {
  name: "PlanInviteForm",
  props: ["planId", "invitationsLeft", "clickLimit"],
  data: function() {
    return {
      formErrors: false,
      formSuccess: false,
      emails: [
        {
          email: "",
          error: false,
          invalid: false,
        },
      ],
    };
  },
  methods: {
    addField: function() {
      this.clickLimit -= 1;
      this.emails.push({ email: "", error: false });
    },
    removeField: function(idx) {
      this.clickLimit += 1;
      this.emails.splice(idx, 1);
    },
    checkForm: function(event) {
      this.formErrors = false;
      const newEmails = [];

      for (let i = 0; i < this.emails.length; i++) {
        if (!this.emails[i].email && this.emails.length > 1) {
          continue;
        } else if (!validEmail(this.emails[i].email)) {
          this.formErrors = true;
          newEmails.push({
            email: this.emails[i].email,
            error: true,
          });
        } else {
          newEmails.push({
            email: this.emails[i].email,
            error: false,
          });
        }
      }

      if (newEmails.length > 0) {
        this.emails = newEmails;
      } else {
        this.formErrors = true;
        this.emails = [
          {
            email: "",
            error: true,
          },
        ];
      }
      this.clickLimit = this.invitationsLeft - this.emails.length;

      if (!this.formErrors) {
        this.sendInvites();
      }

      event.preventDefault();
    },
    sendInvites: function() {
      if (this.planId) {
        for (let i = 0; i < this.emails.length; i++) {
          planService
            .createInvitation(this.planId, this.emails[i].email)
            .then((resp) => {
              if (resp.ok) {
                this.formSuccess = true;
                //this.$emit('close-modal')
              }
            });
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#invite {
  padding: 0 40px;

  .input-wrapper {
    display: flex;
    align-items: center;
    margin-bottom: 23px;
  }

  input.email {
    flex: 2 1 auto;
    margin: 0 12px 0 0;
  }

  .action {
    flex: 1 0 24px;
    width: 24px;
    height: 24px;
  }
  .add {
    background: url("../../assets/icons/add.png") no-repeat center center;
  }
  .remove {
    background: url("../../assets/icons/remove.png") no-repeat center center;
  }
  .blank {
    background: none no-repeat center center;
  }

  input.submit {
    margin: 0 0 40px;
    width: auto;
  }
}

.success-message {
  margin: 0 40px;
  ul {
    li {
      list-style: inside;
      display: list-item;
      padding: 5px 0;
    }
  }
}

.errorMsg {
  margin-top: -20px;
}
</style>
